import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=49fcfed2&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=ts"
export * from "./AccessDenied.vue?vue&type=script&lang=ts"
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=49fcfed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fcfed2",
  null
  
)

export default component.exports